import { Button, Card, EmptyState } from '@ui/themed';
import { t } from 'i18next';

export function ErrorCard({ onReload }: { onReload: () => void }) {
  return (
    <Card>
      <EmptyState
        title={t('titles:error_page')}
        imageType="errorState"
        subtitle={t('errors:generic')}
      >
        <Button onClick={onReload} variant="secondary">
          {t('buttons:reload')}
        </Button>
      </EmptyState>
    </Card>
  );
}
